import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaFileAlt,
  FaTrash,
  FaUserFriends,
  FaCloudUploadAlt,
  FaIdCard,
  FaPassport,
  FaSpinner,
} from "react-icons/fa";
import HoldOn from 'react-hold-on';
import { MdCloudUpload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { uploadFile } from "../../@redux/Action/docAction";
import SigninModal from "../Structure/Modals/SigninModal";
import { selectPaymentOption } from "../../@redux/Reducer/payment";
import { CustomTextField } from "../../utils/Fields";
import { MenuItem } from "@mui/material";
import { getRemitterListByStudentId, insertRemitterData, getRemitterDetailByRelationship } from "../../@redux/Action/Remitter";
import { getOcrDataAPI } from "../../@redux/Action/OCRAction";
import { remitterListSuccess, remitterRelationSuccess, remitterTypeIdSuccess } from "../../@redux/Reducer/Remitter";
import { beneficiaryInsertReset } from "../../@redux/Reducer/beneficiary";
import { resetUID, setUID } from "../../@redux/Reducer/ocrReducer";

const sourceOfFundOptions = [
  { value: "Education", label: "Education Loan" },
  { value: "savings account", label: "Savings Account" },
];

const countryOptions = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "UK", label: "UK" },
];

const isdOptions = [
  { value: "+91", label: "+91" },
  { value: "+1", label: "+1" },
  { value: "+44", label: "+44" },
  { value: "+61", label: "+61" },
];

const RemitterType = ({ setCurrentStep, studentId, onSubmitSuccess }) => {
  const dispatch = useDispatch();
  const sessionValid = useSelector(state => state.config?.sessionValid);
  const remitterRelation = useSelector(state => state.remitter?.remitterRelation);
  const remitterTypeId = useSelector(state => state.remitter?.selectedRemitterIdFromRemitterType);
  const paymentOption = useSelector(state => state.payment?.paymentOption);
  const panDoc = useSelector(state => state.documents?.panDoc);
  const passportDocFrontStudent = useSelector(state => state.documents?.passportDocFrontStudent);
  const passportDocFrontRemitters = useSelector(state => state.documents?.passportDocFrontRemitters);
  const passportDocBackStudent = useSelector(state => state.documents?.passportDocBackStudent);
  const passportDocBackRemitters = useSelector(state => state.documents?.passportDocBackRemitters);
  const aadhaarDocFrontStudent = useSelector(state => state.documents?.aadhaarDocFrontStudent);
  const aadhaarDocFrontRemitters = useSelector(state => state.documents?.aadhaarDocFrontRemitters);
  const aadhaarDocBackStudent = useSelector(state => state.documents?.aadhaarDocBackStudent);
  const aadhaarDocBackRemitters = useSelector(state => state.documents?.aadhaarDocBackRemitters);
  const uuid = useSelector(state => state.ocr?.UID);
  console.log("uuid", uuid);
  console.log("panDoc", panDoc);
  console.log("passportDocFrontStudent", passportDocFrontStudent);
  console.log("passportDocFrontRemitters", passportDocFrontRemitters);
  console.log("passportDocBackStudent", passportDocBackStudent);
  console.log("passportDocBackRemitters", passportDocBackRemitters);
  console.log("aadhaarDocFrontStudent", aadhaarDocFrontStudent);
  console.log("aadhaarDocFrontRemitters", aadhaarDocFrontRemitters);
  console.log("aadhaarDocBackStudent", aadhaarDocBackStudent);
  console.log("aadhaarDocBackRemitters", aadhaarDocBackRemitters);
  
  console.log("remitterRelation", remitterRelation);
  console.log("paymentOption", paymentOption);
  console.log("sessionValid", sessionValid);
  const [remitterType, setRemitterType] = useState("");
  const [signinModal, setSigninModal] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [otherRemitterType, setOtherRemitterType] = useState("");
  const [sourceOfFund, setSourceOfFund] = useState("");
  const [relationship, setRelationship] = useState("");
  const [hoveredType, setHoveredType] = useState(null);
  const [files, setFiles] = useState({});
  const [uploadProgress, setUploadProgress] = useState({});
  const [showRemitterForm, setShowRemitterForm] = useState(false);
  const [isEditing, setIsEditing] = useState(true);
  const [showHelloModal, setShowHelloModal] = useState(false);
  const [selectedRemitter, setSelectedRemitter] = useState(null);
  const [remitterListData, setRemitterListData] = useState([]);
  const [remitterDetails, setRemitterDetails] = useState({
    first_name: "",
    last_name: "", 
    phone: "",
    isd_code: "+91",
    street_address: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    passport_number: "",
    pan_number: "",
    aadhar_number: "",
    dob: "",
    relation_type: "",
    source_of_fund: "",
    status: "Inprogress"
  });

 
  // Generate 4 digit random UID if studentId not available
  useEffect(() => {
    console.log("sessionValid", sessionValid);
    console.log("studentId", studentId);
    if (!sessionValid && !studentId) {
      const generateUID = () => {
        const min = 1000; // Minimum 4 digit number
        const max = 9999; // Maximum 4 digit number
        const randomUID = Math.floor(Math.random() * (max - min + 1)) + min;
        dispatch(setUID(randomUID.toString()));
      };
      generateUID();
    } else {
      console.log("uid",uuid);
    }

  }, [sessionValid, studentId, dispatch]);


  const destination = uuid;
  // const accessToken = sessionStorage.getItem("accessToken");
  const isFromAddRemitter = window.location.pathname.includes("remitter");
  const remitterList = useSelector((state) => state.remitter.remitterListData);
  console.log("remitterList", remitterList);


  const isSessionValid = useSelector((state) => state.config.sessionValid);
  console.log("isSessionValid", isSessionValid);

  // show when add remitter from add remitter page
  useEffect(() => {
    if (isFromAddRemitter) {
      setRemitterType("Other");
      setShowDocuments(true);
    }
    setRemitterListData(remitterList);
  }, [isFromAddRemitter, dispatch, remitterList]);

  const handleSelectRelationship = async(e) => {
    setRelationship(e.target.value);
    await dispatch(remitterRelationSuccess(e.target.value));
  }

  // // Show documents when remitter type is selected
  useEffect(() => {
    if (remitterType) {
      setShowDocuments(true);
      if(isSessionValid) {
        try {
          if(remitterType.toLowerCase() === "other") {
            dispatch(getRemitterDetailByRelationship(studentId, "other"));
            setShowHelloModal(true);
          } else if(remitterType.toLowerCase() === "self") {
            dispatch(getRemitterDetailByRelationship(studentId, "self"));
            // dispatch(remitterTypeIdSuccess("self")); // if user select self then set remitterTypeId to self
            // dispatch(beneficiaryInsertReset())
            console.log("remitter list", remitterRelation);
            if (remitterList && remitterList.length > 0 && studentId) {
              console.log("remitter found", remitterList);
              setCurrentStep((prevStep) => prevStep + 1);
            }
          }
        } catch (error) {
          console.error("Error fetching remitter details:", error);
        }
      }
    }
  }, [remitterType, studentId, isSessionValid, dispatch, setCurrentStep]);


  const handleRemitterSelection = async(remitterId) => {
    if (remitterId === 'new') {
      setShowHelloModal(false);
      await dispatch(remitterTypeIdSuccess(null));
    } else {
      setSelectedRemitter(remitterId);
      console.log("remitterId", remitterId);
      await dispatch(remitterTypeIdSuccess(remitterId));
      setShowHelloModal(false);
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const selfDocuments = ["pan", "self_passport front", "self_passport back"];

  const otherDocuments = [
    "remitters_aadhaar front",
    "remitters_aadhaar back",
    "remitters_pan",
    "student_passport front",
    "student_passport back",
  ];

  const handleFileChange = (e, docType) => {
    const file = e.target.files[0];
    setFiles((prevFiles) => ({
      ...prevFiles,
      [docType]: file,
    }));

    console.log(`Uploading document: ${file.name}`);
    console.log(`Uploading document: ${docType}`);
    console.log(`Uploading document: ${file}`);

    if (!studentId) {
      if (uuid) {
        dispatch(uploadFile(file, docType, uuid));
      } else {
        dispatch(uploadFile(file, docType, studentId));
      }
    } else {
      dispatch(uploadFile(file, docType, studentId));
    }

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress((prev) => ({
        ...prev,
        [docType]: progress,
      }));
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 200);
  };

  const handleRemoveFile = (docType) => {
    setFiles((prevFiles) => {
      const newFiles = { ...prevFiles };
      delete newFiles[docType];
      return newFiles;
    });
    setUploadProgress((prevProgress) => {
      const newProgress = { ...prevProgress };
      delete newProgress[docType];
      return newProgress;
    });
  };

  const getDocumentIcon = (docType) => {
    switch (docType) {
      case "pan":
      case "remitters_pan":
        return <FaIdCard className="me-1 text-success" />;
      case "self_passport front":
      case "student_passport front":
        return <FaPassport className="me-1 text-success" />;
      case "self_passport back":
      case "student_passport back":
        return <FaIdCard className="me-1 text-success" />;
      case "remitters_aadhaar front":
      case "remitters_aadhaar back":
        return <FaIdCard className="me-1 text-success" />;
      default:
        return <MdCloudUpload className="me-1 text-success" />;
    }
  };

  const renderDocumentUpload = (docType) => (
    <div key={docType} className="col-md-4 mb-3">
      <div className="card h-100">
        <div className="card-body p-2">
          <h6 className="card-title mb-2 d-flex align-items-center small">
            {getDocumentIcon(docType)}
            {docType
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </h6>
          {!files || !files[docType] ? (
            <div
              className="upload-area p-2 text-center border rounded cursor-pointer d-flex flex-column justify-content-center align-items-center"
              onClick={() => document.getElementById(docType).click()}
              style={{ height: "80px", background: "#f8f9fa", width: "100%" }}
            >
              <input
                id={docType}
                type="file"
                onChange={(e) => handleFileChange(e, docType)}
                className="d-none"
                accept=".pdf,.jpg,.jpeg,.png"
              />
              <FaCloudUploadAlt className="text-muted mb-1" size={18} />
              <p className="mb-0 small" style={{ fontSize: "0.75rem" }}>
                Click to upload
              </p>
              <small className="text-muted" style={{ fontSize: "0.65rem" }}>
                PDF, JPG, PNG
              </small>
            </div>
          ) : (
            <div
              className="file-info p-2 bg-light rounded d-flex flex-column justify-content-center align-items-center"
              style={{ height: "80px", width: "100%" }}
            >
              <div className="text-center mb-1">
                <FaFileAlt className="text-success mb-1" size={14} />
                <p
                  className="mb-1 small text-truncate"
                  style={{ maxWidth: "100%", fontSize: "0.75rem" }}
                >
                  {files[docType].name}
                </p>
                <button
                  className="btn btn-sm btn-outline-danger py-0"
                  onClick={() => handleRemoveFile(docType)}
                >
                  <FaTrash size={10} />
                </button>
              </div>
              {uploadProgress &&
                uploadProgress[docType] > 0 &&
                uploadProgress[docType] < 100 && (
                  <div className="text-center">
                    <FaSpinner
                      className="fa-spin text-success mb-1"
                      size={14}
                    />
                    <p className="mb-0 small" style={{ fontSize: "0.65rem" }}>
                      Uploading... {uploadProgress[docType]}%
                    </p>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderRemitterOptions = () => (
    <div
      className={`d-flex justify-content-center align-items-center ${
        !remitterType ? "h-100" : ""
      }`}
      style={{ transition: "all 0.3s ease", cursor: "pointer" }}
    >
      <div
        className="remitter-option me-3 text-center"
        onClick={() => {
          setRemitterType("Self");
          setOtherRemitterType("");
        }}
        onMouseEnter={() => setHoveredType("Self")}
        onMouseLeave={() => setHoveredType(null)}
      >
        <div
          className={`circle-icon d-flex justify-content-center align-items-center mx-auto mb-2 border ${
            remitterType === "Self" || hoveredType === "Self"
              ? "border-success"
              : ""
          }`}
          style={{
            width: remitterType ? "90px" : "100px",
            height: remitterType ? "90px" : "100px",
            borderRadius: "10px",
            transition: "all 0.3s ease",
          }}
        >
          <FaUser
            className={
              remitterType === "Self" || hoveredType === "Self"
                ? "text-success"
                : "text-secondary"
            }
            size={remitterType ? 45 : 50}
          />
        </div>
        <h4
          className={`mt-2 ${
            remitterType === "Self" || hoveredType === "Self"
              ? "text-success"
              : "text-muted"
          }`}
          style={{ fontSize: remitterType ? "1.4rem" : "1.5rem" }}
        >
          Self
        </h4>
      </div>
      <div
        className="remitter-option text-center me-3"
        onClick={() => setRemitterType("Other")}
        onMouseEnter={() => setHoveredType("Other")}
        onMouseLeave={() => setHoveredType(null)}
      >
        <div
          className={`circle-icon d-flex justify-content-center align-items-center mx-auto mb-2 border ${
            remitterType === "Other" || hoveredType === "Other"
              ? "border-success"
              : ""
          }`}
          style={{
            width: remitterType ? "90px" : "100px",
            height: remitterType ? "90px" : "100px",
            borderRadius: "10px",
            transition: "all 0.3s ease",
          }}
        >
          <FaUserFriends
            className={
              remitterType === "Other" || hoveredType === "Other"
                ? "text-success"
                : "text-secondary"
            }
            size={remitterType ? 45 : 50}
          />
        </div>
        <h4
          className={`mt-2 ${
            remitterType === "Other" || hoveredType === "Other"
              ? "text-success"
              : "text-muted"
          }`}
          style={{ fontSize: remitterType ? "1.2rem" : "1.5rem" }}
        >
          Other
        </h4>
      </div>
    </div>
  );

  const handleNext = () => {
    if (remitterType && !sessionValid) {
      setSigninModal(true);
    } else if (isFromAddRemitter && !showRemitterForm) {
      const ocrData = dispatch(getOcrDataAPI(uuid));
      ocrData.then((data) => {
        console.log("OCR DATA", data.remitter);
        setRemitterDetails({
          ...remitterDetails,
          first_name: data.remitter.First_name || "",
          last_name: data.remitter.Surname || "", 
          phone: data.remitter.phone || "",
          isd_code: data.remitter.isdCode || "+91",
          street_address: data.remitter.streetAddress || "",
          city: data.remitter.city || "",
          state: data.remitter.state || "",
          pincode: data.remitter.pincode || "",
          country: data.remitter.country || "",
          passport_number: data.remitter.Passport_number || "",
          pan_number: data.remitter.permanent_Account_Number || "",
          aadhar_number: data.remitter.Aadhar_Number || "",
          dob: data.remitter.Date_of_Birth || "",
          relation_type: data.remitter.relation_type || "",
          source_of_fund: data.remitter.source_of_fund || ""
        });
      }).catch((error) => {
        console.error("Error fetching OCR data:", error);
      });
      setShowRemitterForm(true);
    } else {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handleSubmit = async () => {
    if (!sessionValid) {
      setSigninModal(true);
      return;
    }

    // Validate required fields if coming from remitter page
    if (isFromAddRemitter) {
      const requiredFields = ['first_name', 'last_name', 'phone', 'dob', 'pan_number', 'passport_number', 'country', 'city', 'state', 'pincode'];
      const missingFields = requiredFields.filter(field => !remitterDetails[field]);
      
      if (missingFields.length > 0) {
        alert(`Please fill in all required fields: ${missingFields.join(', ')}`);
        return;
      }
    }

    if (onSubmitSuccess) {
      const remitterDataToSubmit = {
        first_name: remitterDetails.first_name,
        last_name: remitterDetails.last_name,
        phone: remitterDetails.phone,
        isd_code: remitterDetails.isd_code,
        street_address: remitterDetails.street_address,
        city: remitterDetails.city,
        state: remitterDetails.state,
        pincode: remitterDetails.pincode,
        country: remitterDetails.country,
        passport_number: remitterDetails.passport_number,
        pan_number: remitterDetails.pan_number,
        aadhar_number: remitterDetails.aadhar_number,
        dob: remitterDetails.dob,
        relation_type: relationship || remitterDetails.relation_type,
        source_of_fund: sourceOfFund || remitterDetails.source_of_fund,
        status: "Inprogress"
      };
      await dispatch(insertRemitterData(remitterDataToSubmit,studentId));
      await onSubmitSuccess();
    }
  };

  const handleSourceOfFundChange = async (e) => {
    const selectedOption = e.target.value;
    setSourceOfFund(selectedOption);
    console.log("Selected Source of Fund:", selectedOption);
    await dispatch(selectPaymentOption({ paymentPurpose: selectedOption }));
  };

  const handleInputChange = (e, field) => {
    setRemitterDetails({ ...remitterDetails, [field]: e.target.value });
  };

  return (
    <>
      <div className="remitter-type-container h-100 d-flex flex-column justify-content-center">
        {!isFromAddRemitter && !remitterType && (
          <h2
            className="text-center mb-5 text-success"
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            Who Will Pay?
          </h2>
        )}
        {!showRemitterForm ? (
          <>
            <div
              className={`d-flex ${
                !remitterType && !isFromAddRemitter
                  ? "justify-content-center"
                  : "justify-content-between"
              } align-items-center w-100`}
            >
              {!remitterType && !isFromAddRemitter ? (
                renderRemitterOptions()
              ) : (
                <>
                  {!isFromAddRemitter && (
                    <div
                      className="d-flex justify-content-start align-items-center"
                      style={{ transition: "all 0.3s ease" }}
                    >
                      {renderRemitterOptions()}
                    </div>
                  )}
                  <div
                    className="card"
                    style={{ width: "300px", borderRadius: "15px" }}
                  >
                    <div className="w-100 mb-3 text-center">
                      <div className="card-body p-3">
                        <h6 className="card-title mb-3 text-success font-weight-bold">
                          Source Of Fund
                        </h6>
                        <div className="custom-select position-relative">
                          <select
                            className="form-select shadow-none border border-success"
                            value={sourceOfFund}
                            onChange={handleSourceOfFundChange}
                            style={{
                              borderRadius: "10px",
                              padding: "10px 15px",
                              appearance: "none",
                              paddingRight: "40px",
                            }}
                          >
                            <option value="">Select Source of Fund</option>
                            {sourceOfFundOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="remitter-option text-center"
                    style={{
                      transition: "all 0.3s ease",
                      opacity: 1,
                      transform: "translateX(0)",
                    }}
                  >
                    <div
                      className="card"
                      style={{ width: "250px", borderRadius: "15px" }}
                    >
                      <div className="card-body p-4">
                        <h6 className="card-title mb-3 text-success font-weight-bold">
                          Relationship
                        </h6>
                        <div className="custom-select position-relative">
                          <select
                            className="form-select shadow-none border border-success"
                            value={relationship}
                            onChange={handleSelectRelationship}
                            style={{
                              borderRadius: "10px",
                              padding: "10px 15px",
                              appearance: "none",
                              paddingRight: "40px",
                            }}
                            disabled={remitterType === "Self"}
                          >
                            <option value="">Select Relationship</option>
                            {["Father", "Mother", "Brother", "Sister"].map(
                              (relation) => (
                                <option
                                  key={relation}
                                  value={relation.toLowerCase()}
                                >
                                  {relation}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {showDocuments && (
              <div
                className="mt-4"
                style={{
                  transition: "all 0.3s ease",
                  opacity: showDocuments ? 1 : 0,
                  transform: showDocuments
                    ? "translateY(0)"
                    : "translateY(20px)",
                }}
              >
                <h4 className="mb-3">Required Documents</h4>
                <div className="row">
                  {remitterType === "Self"
                    ? selfDocuments.map(renderDocumentUpload)
                    : otherDocuments.map(renderDocumentUpload)}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="my-auto">
            <div className="roboto-medium mx-3 d-flex flex-column h-100">
              <div className="flex-grow-1 d-flex flex-column">
                <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="First Name (Given Name)" 
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.first_name}
                      onChange={(e) => handleInputChange(e, "first_name")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Last Name (Family Name)"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.last_name}
                      onChange={(e) => handleInputChange(e, "last_name")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <div className="d-flex gap-2">
                      <CustomTextField
                        select
                        label="ISD Code"
                        variant="outlined"
                        style={{ width: "40%" }}
                        value={remitterDetails.isd_code}
                        onChange={(e) => handleInputChange(e, "isd_code")}
                      >
                        {isdOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </CustomTextField>
                      <CustomTextField
                        label="Phone Number"
                        variant="outlined"
                        style={{ width: "60%" }}
                        required={isFromAddRemitter}
                        value={remitterDetails.phone}
                        onChange={(e) => handleInputChange(e, "phone")}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Date of Birth"
                      type="date"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.dob}
                      onChange={(e) => handleInputChange(e, "dob")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="PAN Number"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.pan_number}
                      onChange={(e) => handleInputChange(e, "pan_number")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Passport Number"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.passport_number}
                      onChange={(e) => handleInputChange(e, "passport_number")}
                    />
                  </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      select
                      label="Country"
                      value={remitterDetails.country}
                      onChange={(e) => handleInputChange(e, "country")}
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                    >
                      {countryOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="City"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.city}
                      onChange={(e) => handleInputChange(e, "city")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="State"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.state}
                      onChange={(e) => handleInputChange(e, "state")}
                    />
                  </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Pincode"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.pincode}
                      onChange={(e) => handleInputChange(e, "pincode")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Street Address"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.street_address}
                      onChange={(e) => handleInputChange(e, "street_address")}
                    />
                  </div>
                  <div className="form-group" style={{ flexBasis: "30%" }}>
                    <CustomTextField
                      label="Aadhar Number"
                      variant="outlined"
                      fullWidth
                      required={isFromAddRemitter}
                      value={remitterDetails.aadhar_number}
                      onChange={(e) => handleInputChange(e, "aadhar_number")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-end p-4">
        {remitterType && (
          <button
            className="btn btn-outline-success btn-md"
            onClick={
              isFromAddRemitter
                ? showRemitterForm
                  ? handleSubmit
                  : handleNext
                : handleNext
            }
          >
            {isFromAddRemitter
              ? showRemitterForm
                ? "Submit"
                : "Next"
              : "Next"}
          </button>
        )}
      </div>

      <SigninModal
        signinModal={signinModal}
        setSigninModal={setSigninModal}
        destination={destination}
        setCurrentStep={setCurrentStep}
        style={{ maxWidth: "800px", width: "90%" }}
      />
      {/* choose remitter for when user comes from dashboard page and the status is approved */}

      {showHelloModal && !isFromAddRemitter && remitterListData?.length > 0 && (
        <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.7)'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-header bg-success text-white border-0 rounded-top-4">
                <h4 className="modal-title fw-bold">Select Remitter</h4>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowHelloModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="form-group">
                  <label className="form-label mb-3">Choose an existing remitter or add new</label>
                  <select 
                    className="form-select form-select-lg mb-3 shadow-sm" 
                    aria-label="Select Remitter"
                    onChange={(e) => handleRemitterSelection(e.target.value)}
                  >
                    <option value="">Select a remitter</option>
                    <option value="new" className="text-success">+ Add New Remitter</option>
                    {remitterListData.map((remitter, index) => (
                      <option key={index} value={remitter.remitter_id}>
                        {`${remitter.first_name} ${remitter.last_name}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RemitterType;